import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item"];

  connect() {
    this.closeAll();
  }

  toggle(event) {
    event.preventDefault();

    const item = event.currentTarget.closest('[data-header-dropdown-target="item"]');
    if (!item) { return }

    const isOpen = item.classList.contains("is-open");

    this.closeAll();
    if (isOpen) { return }

    this.open(item);
  }

  closeFromWindow(event) {
    if (this.element.contains(event.target)) { return }

    this.closeAll();
  }

  closeAll() {
    this.itemTargets.forEach((item) => this.close(item));
  }

  open(item) {
    item.classList.add("is-open");

    const button = item.querySelector("[data-header-dropdown-button]");
    const menu = item.querySelector("[data-header-dropdown-menu]");

    if (button) {
      button.setAttribute("aria-expanded", "true");
    }

    if (menu) {
      menu.hidden = false;
    }
  }

  close(item) {
    item.classList.remove("is-open");

    const button = item.querySelector("[data-header-dropdown-button]");
    const menu = item.querySelector("[data-header-dropdown-menu]");

    if (button) {
      button.setAttribute("aria-expanded", "false");
    }

    if (menu) {
      menu.hidden = true;
    }
  }
}
